import AdminLayoutConstants from "./admin.layout.constants";

export const LayoutConstants = {

  /**
   * Layouts
   */
  ...AdminLayoutConstants
}